import React from 'react';
import { useTranslation } from 'react-i18next';

// MUI Icons
import { Switch } from '@mui/material';
import { Delete } from '@mui/icons-material';

// Custom Components
import TableHeaderButton from './TableHeaderButton';
import { ITableHeaderButtonShowDeletedProps } from '@/@types/ui/Table';

const TableHeaderButtonShowDeleted = (props: ITableHeaderButtonShowDeletedProps) => {
  const { t } = useTranslation();
  const { showDeleted, onClick, ...rest } = props;

  return (
    <TableHeaderButton
      startIcon={<Delete />}
      endIcon={<Switch checked={showDeleted} size="small" color="primary" />}
      checked={showDeleted}
      variant="outlined"
      tooltip={t('buttons.show_deleted') ?? ''}
      sx={{ display: { xs: 'none', sm: 'flex' } }}
      {...rest}
      onClick={onClick}
    >
      {t('buttons.show_deleted')}
    </TableHeaderButton>
  );
};

export default TableHeaderButtonShowDeleted;
